import { privateApi } from 'services';
import { ContentLibraryVideo } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchVideo = async (videoId: string): Promise<ContentLibraryVideo> =>
    privateApi.get<ContentLibraryVideo>(`content-library/video-items/${videoId}`);

const fetchVideos = async (businessAccountId: string): Promise<ContentLibraryVideo[]> =>
    privateApi.get<ContentLibraryVideo[]>(`business-accounts/${businessAccountId}/content-library/video-items`);

const uploadVideo = async (
    businessAccountId: string,
    formData: FormData,
    onProgressChange?: (e: ProgressEvent<XMLHttpRequestEventTarget>) => void,
): Promise<unknown> =>
    privateApi.postMultipart(
        `business-accounts/${businessAccountId}/content-library/video-items`,
        formData,
        false,
        onProgressChange,
    );

const archiveVideo = async (videoId: string): Promise<ContentLibraryVideo> =>
    privateApi.post<ContentLibraryVideo>(`content-library/video-items/${videoId}/archive`);

const unarchiveVideo = async (videoId: string): Promise<ContentLibraryVideo> =>
    privateApi.post<ContentLibraryVideo>(`content-library/video-items/${videoId}/unarchive`);

const deleteVideo = async (videoId: string): Promise<ContentLibraryVideo> =>
    privateApi.post<ContentLibraryVideo>(`content-library/video-items/${videoId}/delete`);

const updateVideoYouTubeUrl = async (videoId: string, youtubeUrl: string | null): Promise<ContentLibraryVideo> =>
    privateApi.put<ContentLibraryVideo>(`content-library/video-items/${videoId}`, {
        youtubeUrl,
    });

export const ContentLibraryVideoGateway = {
    fetchVideo,
    fetchVideos,
    uploadVideo,
    archiveVideo,
    unarchiveVideo,
    deleteVideo,
    updateVideoYouTubeUrl,
};

const cancelableFetchVideo = async (videoId: string): Promise<ContentLibraryVideo> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ContentLibraryVideo>(
        `content-library/video-items/${videoId}`,
    );

const cancelableFetchVideos = async (businessAccountId: string): Promise<ContentLibraryVideo[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ContentLibraryVideo[]>(
        `business-accounts/${businessAccountId}/content-library/video-items`,
    );

const cancelableDeleteVideo = async (videoId: string, customEventName: string): Promise<ContentLibraryVideo> =>
    privateApiWithRouteLeavingCancelation.postWithAbortControlOnCustomEvent<ContentLibraryVideo>(
        `content-library/video-items/${videoId}/delete`,
        {},
        { customEventName },
    );

export const CancelableContentLibraryVideoGateway = {
    cancelableFetchVideo,
    cancelableFetchVideos,
    cancelableDeleteVideo,
};
